import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Techstack() {
  return (
    <section className="techstack_par p-100 text_second_text">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <h2 className="text-center">
              <span>Tech Stack</span> Used
            </h2>
            <div className="tech_main_stack">
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/truth-gpt/tech_1.png"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={251}
                    height={92}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Mobile Platforms </h5>
                  <p>iOS and Android</p>
                </div>
              </div>
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/truth-gpt/tech_2.png"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={103}
                    height={92}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Mobile App Development Framework</h5>
                  <p>Flutter</p>
                </div>
              </div>
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/truth-gpt/tech_3.png"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={103}
                    height={92}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Admin Panel</h5>
                  <p>Node JS</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Techstack;
